<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0 pb-1">
        <b-link class="brand-logo">
          <b-img :src="logoUic" width="100" heigth="100" />
        </b-link>

        <b-card-title class="mb-1">
          Welcome to IDI Cabang Jakpus!
        </b-card-title>
        <!-- <b-card-text class="mb-2">
                                Please sign-in to your account.
                              </b-card-text> -->

        <!-- form -->
        <validation-observer ref="loginForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- email -->
            <b-form-group label-for="email" label="Email">
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  placeholder="john@example.com"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <!-- forgot password tidak di pake-->
              <!-- <div class="d-flex justify-content-between">
                    <label for="password">Password</label>
                    <b-link>
                      <small>Forgot Password?</small>
                    </b-link>
                  </div> -->
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    placeholder="Password"
                    autocomplete="on"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="login"
            >
              Sign in
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BImg,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import API from "@/api";
import storage from "@/helpers/storage";
import { TOKEN_CURRENT, ROLE_ID } from "@/constants";
import { initialAbility } from "@/libs/acl/config";
import logoUic from "@/assets/images/logo/logo-new-idi.png";

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BImg,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "",
      password: "",
      status: "",
      // validation rules
      required,
      email,
      logoUic,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    async login() {
      let isRedirect = false;
      try {
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", true);

        const form = {
          oadm_password: this.password,
          oadm_email: this.userEmail,
        };
        const { data } = await API.auth.login(form);

        this.$store.commit("user/UPDATE_USER_LOGGED_IN", data.user);
        storage.setStorage(TOKEN_CURRENT, data.token);
        storage.setStorage(ROLE_ID, data.user.role_id);
        this.$ability.update(
          initialAbility[data.user.role_id] || initialAbility[0]
        );
        this.handleMsgSuccess("Successfully logged in");
        isRedirect = true;
      } catch (error) {
        console.log(error);
        this.handleMsgErrors(
          error,
          "Email atau Password salah, silahkan coba lagi!"
        );
      } finally {
        if (isRedirect) {
          if (Number(storage.getStorage(ROLE_ID)) === 7) {
            await this.$router.replace("/member");
          } else {
            await this.$router.replace("/");
          }
        }
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", false);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
